import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'antd';

import { OptionHeading, SliderWrapper } from '../../styles';

const marks = {
  0: 'Sharper',
  50: 'Default',
  100: 'Smoother',
};

const HeatmapContrast = ({ heatmapContrast = 50, onChangeContrast }) => (
  <>
    <OptionHeading>Heatmap Spread</OptionHeading>
    <p>
      Adjust how quickly dense areas saturate. Lower values keep hotspots sharper.
      Higher values blend points together sooner.
    </p>
    <SliderWrapper>
      <Slider
        min={0}
        max={100}
        step={10}
        marks={marks}
        value={heatmapContrast}
        onChange={onChangeContrast}
      />
    </SliderWrapper>
  </>
);

HeatmapContrast.propTypes = {
  heatmapContrast: PropTypes.number,
  onChangeContrast: PropTypes.func.isRequired,
};

export default HeatmapContrast;
